import * as RadixToast from '@radix-ui/react-toast';
import { AlertTriangle, Check, Info, X } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

// LOT URGENT P0 FE-1 — primitives Radix Toast stylees Tailwind.
// Toast Lot 1 : prop variant ('error'|'success'|'warning'|'info') pilote
// l'icône et la couleur d'accent. Rétrocompat : variant absent → 'error'
// (anciens callers comme l'apiInterceptor 429 continuent intacts).
// duration override prop (défaut 5000ms). aria-label Close localisé.

export const ToastProviderRadix = RadixToast.Provider;

export function ToastViewport() {
  return (
    <RadixToast.Viewport className="fixed bottom-6 right-6 z-[70] m-0 flex w-full max-w-sm flex-col gap-2 outline-none" />
  );
}

const VARIANT_STYLES = {
  error:   { Icon: AlertTriangle, iconClass: 'text-red-400' },
  success: { Icon: Check,         iconClass: 'text-green-400' },
  warning: { Icon: AlertTriangle, iconClass: 'text-amber-400' },
  info:    { Icon: Info,          iconClass: 'text-blue-400' },
};

export function ToastItem({ variant = 'error', title, description, open, onOpenChange, duration = 5000 }) {
  const { t } = useLanguage();
  const { Icon, iconClass } = VARIANT_STYLES[variant] || VARIANT_STYLES.error;
  return (
    <RadixToast.Root
      open={open}
      onOpenChange={onOpenChange}
      duration={duration}
      className="flex items-start gap-3 rounded-xl border border-slate-700 bg-slate-800 p-4 text-white shadow-2xl"
    >
      <Icon className={`w-5 h-5 flex-shrink-0 mt-0.5 ${iconClass}`} />
      <div className="flex-1 min-w-0">
        <RadixToast.Title className="text-sm font-medium">{title}</RadixToast.Title>
        <RadixToast.Description className="text-xs mt-1 text-slate-300 whitespace-pre-line">
          {description}
        </RadixToast.Description>
      </div>
      <RadixToast.Close
        className="p-1 rounded-lg hover:bg-slate-700"
        aria-label={t('common.close')}
      >
        <X className="w-4 h-4" />
      </RadixToast.Close>
    </RadixToast.Root>
  );
}
